<template>
<Layout>
    <template #content>
      <div class="join_alone">
        <pageHead device="desktop" page="forgot"/>

        <div class="join_alone-con">
          <div class="join_alone_bg">
            <div class="joinbg_li li_s1">
              <div class="nicon icon-point"></div>
              <p>{{ $t("store.footer02_title") }}</p>
            </div>
            <div class="joinbg_li li_s2">
              <div class="nicon icon-fast"></div>
              <p>{{ $t("store.footer03_title") }}</p>
            </div>
            <div class="joinbg_li li_s3">
              <div class="nicon icon-diamond"></div>
              <p>{{ $t("store.footer04_title") }}</p>
            </div>

            <div class="modal-main forgot">
              <div class="title">{{ $t("store.pw.forgot") }}</div>
              <b-form @submit.stop.prevent="onSubmit">
                  
                <b-form-group :label="$t('store.type')" label-for="input-type">
                  <b-form-select
                    id="input-type"
                    name="input-type"
                    v-model="$v.form.type.$model"
                    :state="validateState('type')"
                    aria-describedby="input-type-feedback"
                  >
                    <Option value="account">{{ $t("store.user.account") }}</Option>
                    <Option value="mobile">{{ $t("store.user.phone_number") }}</Option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input-name-feedback">{{ $t("store.btn.error_feedback") }}</b-form-invalid-feedback>
                </b-form-group>
                
                <b-form-group :label="$v.form.type.$model == 'account' ? $t('store.plz_enter_username') : $t('store.plz_enter_user_mobile')"  label-for="input-name">
                  <b-form-input
                    id="input-name"
                    name="input-name"
                    v-model="$v.form.name.$model"
                    :state="validateState('name')"
                    aria-describedby="input-name-feedback"
                    trim
                  />
                  <b-form-invalid-feedback id="input-name-feedback">{{ $t("store.btn.error_feedback") }}</b-form-invalid-feedback>
                </b-form-group>
                <!-- <b-form-group :label="$v.form.type.$model == 'account' ? this.$t('store.plz_enter_username') : this.$t('store.plz_enter_user_mobile')" label-for="input-name">
                  <b-form-input
                    id="input-name"
                    name="input-name"
                    v-model="$v.form.name.$model"
                    :state="validateState('name')"
                    aria-describedby="input-name-feedback"
                    trim
                  />
                  <b-form-invalid-feedback id="input-name-feedback">{{ $t("store.btn.error_feedback") }}</b-form-invalid-feedback>
                </b-form-group>-->

                <b-form-group :label="$t('store.btn.CAPTCHA')" label-for="input-captchas">
                  <b-form-input
                    id="input-captchas"
                    name="input-captchas"
                    v-model="$v.form.captchas.$model"
                    :state="validateState('captchas')"
                    aria-describedby="input-captchas-feedback"
                    trim
                  />
                  <div class="input-group-prepend">
                    <img :src="CaptchasImg" @click="_changeCaptchas" />
                  </div>
                  <b-form-invalid-feedback id="input-captchas-feedback">{{ $t("store.btn.error_feedback") }}</b-form-invalid-feedback>
                </b-form-group> 

                <!--<b-button @click="resetForm()" variant="cancel">{{ $t("store.btn.reset") }}</b-button>-->
                <b-button
                  type="submit"
                  variant="submit"
                  :style="ButSendCode.disabled ? 'background-color: #dc3545;border-color: #dc3545;cursor: wait;' : ''"
                  :disabled="ButSendCode.disabled"
                >
                  {{ ButSendCode.text }}
                </b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </template>
</Layout>
</template>
<script>
const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    name: "forgot",
    middleware: ["checkNoLogin"],
    mixins: [validationMixin],
    components: { pageHead,Layout },
    data() {
      return {
        form: {
          type: 'account',
          name: null,
          captchas: null,
        },
        ButSendCode: this.handleButSendCode(),
      };
    },
    validations: {
      form: {
        type: { required },
        name: { required },
        captchas: { required },
      },
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      onSubmit() {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }

        this.ButSendCode.disabled = true;
        this.ForgotPassword(this.form).then((res) => {
          if (parseFloat(res).toString() != "NaN") {
            this.setReciprocal(res);
          } else if (res) {
            this.setReciprocal(this.ButSendCode.seconds);
          } else {
            this.ButSendCode.disabled = false;
          }
          this._changeCaptchas();
        });
      },      
      setReciprocal(seconds) {
        this.ButSendCode.reciprocal = seconds;
        this.ButSendCode.timer = setInterval(() => {
          if (this.ButSendCode.reciprocal > 0) {
            this.ButSendCode.reciprocal--;
            this.ButSendCode.text =
              `${this.ButSendCode.reciprocal}` + this.$t("store.tip_mobile_second_reset");
          } else {
            this.ButSendCode.disabled = false;
            this.ButSendCode.text = this.$t("store.btn.send_new_pw");
            clearInterval(this.ButSendCode.timer);
          }
        }, 1000);
      },
      handleButSendCode() {
        return {
          disabled: false,
          check: false,
          seconds: 60 * 5,
          reciprocal: 0,
          text: this.$t("store.btn.send_new_pw"),
          timer: null,
        };
      },
      changeLang() {
        this.ButSendMobileCode = this.handleButSendCode();
      },
      ...mapActions(["_changeCaptchas"]),
      ...mapActions("account", ["ForgotPassword"]),
    },    
    mounted() {
      this.changeLang();
    },
    watch: {
      "$i18n.locale"(language) {
        this.changeLang();
      },
    },
    computed: {
      ...mapState(["CaptchasImg"]),
    },
  };
</script>